module.exports = __webpack_public_path__ + "media/images/prizes__prize--placeholder-ea48057e57b6077392b0327ffd665ab1.png";